const LETTERS = 'ABCDEFGHJKLMNPQRSTUVWXYZ';

function generateRoomCode() {
  let code = '';
  for (let i = 0; i < 4; i++) {
    code += LETTERS[Math.floor(Math.random() * LETTERS.length)];
  }
  return code;
}

function isValidRoomCode(code) {
  return /^[A-Z]{4}$/.test(code);
}

export { generateRoomCode, isValidRoomCode };
